module.exports = __webpack_public_path__ + "static/media/privacy_en.5c6b6a0c.txt";